import { Immutable } from "immer";

import type { SpacingSubBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

/**
 * Reproduce the exact global class strings emitted by the Django partial
 * ``tsicommon_cms/blocks/sub-blocks/spacing-sub-block.html``:
 *
 *   {% if spacing.top_spacing %}top-spacing top-{{ spacing.top_spacing }}{% endif %}
 *   ...
 *
 * These are GLOBAL classes styled by
 * ``tsi-common-react/src/styles/blocks/sub-blocks/_spacing.scss`` (NOT the
 * CSS-module ``getSpacingClasses`` in ``tsi-common-react/src/components/_spacing/spacing``,
 * which produces hashed names stearns' global SCSS does not match). Use this
 * helper for every stearns block that renders the spacing sub-block so the SSR
 * output is byte-identical to the legacy server render.
 */
export const getSpacingClasses = (
    spacing: Immutable<SpacingSubBlock> | null | undefined,
): string => {
    if (!spacing) {
        return "";
    }
    return concatClassNames([
        spacing.top_spacing ? `top-spacing top-${spacing.top_spacing}` : "",
        spacing.top_inner_spacing
            ? `top-inner-spacing top-inner-${spacing.top_inner_spacing}`
            : "",
        spacing.bottom_spacing
            ? `bottom-spacing bottom-${spacing.bottom_spacing}`
            : "",
        spacing.bottom_inner_spacing
            ? `bottom-inner-spacing bottom-inner-${spacing.bottom_inner_spacing}`
            : "",
    ]);
};
